export default __webpack_public_path__ + "static/franchise-5-59f2ab48faa50fa0f45764296d203f95.jpg";